import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { canAny } from "@/utils/permissions";
import { useMemo } from "react";

export const Forbidden = () => {
  const navigate = useNavigate();
  const { permissions, adminType } = usePermissions();

  // Find the first accessible page
  const firstAccessiblePage = useMemo(() => {
    if (!permissions) return null;

    // Check pages in priority order
    if (canAny(permissions, ['dashboard.analytics.view'], adminType)) {
      return { path: '/', label: 'Dashboard' };
    }
    if (canAny(permissions, ['programs.published.view', 'programs.draft.view'], adminType)) {
      return { path: '/programs-v2', label: 'Programs' };
    }
    if (canAny(permissions, ['certificates.main.view'], adminType)) {
      return { path: '/certifications', label: 'Certificates' };
    }
    if (canAny(permissions, ['users.main.view'], adminType)) {
      return { path: '/users', label: 'Users' };
    }
    if (canAny(permissions, ['categories.main.view'], adminType)) {
      return { path: '/categories', label: 'Categories' };
    }
    if (canAny(permissions, ['subscriptions.main.view'], adminType)) {
      return { path: '/subscriptions', label: 'Subscriptions' };
    }
    if (canAny(permissions, ['payments.main.view', 'payments.authorization.view'], adminType)) {
      return { path: '/payments', label: 'Payments' };
    }
    if (canAny(permissions, ['supportTickets.main.view', 'supportTickets.chat.view'], adminType)) {
      return { path: '/tickets', label: 'Support Tickets' };
    }
    if (canAny(permissions, ['admin.settings.view'], adminType)) {
      return { path: '/settings', label: 'Settings' };
    }
    if (canAny(permissions, ['admin.staff.view', 'admin.roles.view'], adminType)) {
      return { path: '/settings/staff-roles', label: 'Staff & Roles' };
    }

    return null; // No accessible pages
  }, [permissions, adminType]);

  return (
    <div className="flex min-h-[600px] flex-col items-center justify-center space-y-4 text-center">
      <ShieldAlert className="h-24 w-24 text-destructive" />
      <div className="space-y-2">
        <h1 className="text-4xl font-bold tracking-tighter">403 - Access Denied</h1>
        <p className="text-muted-foreground max-w-md">
          You don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </p>
      </div>
      <div className="flex gap-2">
        <Button onClick={() => navigate(-1)} variant="outline">
          Go Back
        </Button>
        {firstAccessiblePage ? (
          <Button onClick={() => navigate(firstAccessiblePage.path)}>
            Go to {firstAccessiblePage.label}
          </Button>
        ) : (
          <Button onClick={() => navigate('/help')}>
            Go to Help
          </Button>
        )}
      </div>
    </div>
  );
};

